import { View } from "@gaming/srvg-classes-core";

export class OverlayContainerView extends View {
    animationSpeedInMs: number;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'overlayContainerView';
        super( options );
        this.animationSpeedInMs = 400;
        this.hide( false );
    }

    show( animate?:boolean ) {
        var speed = this.animationSpeedInMs;
        // do not animate and switch class directly if animation isn't wished here
        if(!animate) {
            speed = 0;
        }

        this.$domNode.removeClass('hidden', speed);

        if(this.$domNode.css('display') == "none"){
            this.$domNode.css('display', '');
        }

        this.isShown = true;
    }

    hide( animate?:boolean, callback?:any ) {
        callback = callback || function(){};

        var speed = this.animationSpeedInMs;
        // do not animate and switch class directly if animation isn't wished here
        if(!animate) {
            speed = 0;
        }

        this.$domNode.addClass('hidden', speed, callback);
        this.isShown = false;
    }
}